import { BinInfo, BinTypeList, CleanerList, ContainerList, ContractList, DepotList, DistrictList, EnquiryType, RecylcableList, ZoneList } from "./state";

export function initStaticAction(enquiryType:EnquiryType[],districtList:DistrictList[],binList:BinInfo[]){
    return {
        type: '@@StaticInfoState/initBinListAction' as const ,
        enquiryType,
        districtList,
        binList
    }
}

export function ChangeBinListAction(binList:BinInfo[]){
    return {
        type: '@@StaticInfoState/ChangeBinListAction' as const ,
        binList
    }
}

export function InitBinListAction(binList:BinInfo[]){
    return {
        type: '@@StaticInfoState/InitBinListAction' as const ,
        binList
    }
}

export function InitBinGroupListAction(binGroupList:BinInfo[]){
    return {
        type: '@@StaticInfoState/InitBinGroupListAction' as const ,
        binGroupList
    }
}

export function InitCleanerListAction(cleanerList:CleanerList[]){
    return {
        type: '@@StaticInfoState/InitCleanerListAction' as const ,
        cleanerList
    }
}

export function InitContractListAction(contractList:ContractList[]){
    return {
        type: '@@StaticInfoState/InitContractListAction' as const ,
        contractList
    }
}

export function InitDistrictListAction(districtList:DistrictList[]){
    return {
        type: '@@StaticInfoState/InitDistrictListAction' as const ,
        districtList
    }
}

export function InitBinTypeListAction(binTypeList:BinTypeList[]){
    return {
        type: '@@StaticInfoState/InitBinTypeListAction' as const ,
        binTypeList
    }
}

export function initContainerListAction(containerList:ContainerList[]){
    return {
        type: '@@StaticInfoState/initContainerListAction' as const ,
        containerList
    }
}

export function initReyclableListAction(recylcableList:RecylcableList[]){
    return {
        type: '@@StaticInfoState/initReyclableListAction' as const ,
        recylcableList
    }
}

export function initDepotListAction(depotList:DepotList[]){
    return {
        type: '@@StaticInfoState/initDepotListAction' as const ,
        depotList
    }
}

export function initZoneListAction(zoneList:ZoneList[]){
    return {
        type: '@@StaticInfoState/initZoneListAction' as const ,
        zoneList
    }
}

export function changeFilteredZoneListAction(filteredZoneList:ZoneList[]){
    return {
        type: '@@StaticInfoState/changeFilteredZoneList' as const ,
        filteredZoneList
    }
}





export type StaticInfoAction =
|ReturnType<typeof initStaticAction>
|ReturnType<typeof ChangeBinListAction>
|ReturnType<typeof InitBinListAction>
|ReturnType<typeof InitBinGroupListAction>
|ReturnType<typeof InitCleanerListAction>
|ReturnType<typeof InitContractListAction>
|ReturnType<typeof InitDistrictListAction>
|ReturnType<typeof InitBinTypeListAction>
|ReturnType<typeof initContainerListAction>
|ReturnType<typeof initReyclableListAction>
|ReturnType<typeof initDepotListAction>
|ReturnType<typeof initZoneListAction>
|ReturnType<typeof changeFilteredZoneListAction>